<script lang="ts">
	import { broadcastText, type TextEntity, type Attachment } from '@andresot/protocol';
	import MediaAlbum from './MediaAlbum.svelte';
	import MessageText from './MessageText.svelte';
	import BroadcastLink from './BroadcastLink.svelte';
	let {
		title,
		body,
		textEntities = [],
		attachments = [],
		link,
		messageId,
		preview = false
	}: {
		title: string;
		body: string;
		textEntities?: TextEntity[];
		attachments?: Attachment[];
		link?: { label: string; url: string };
		messageId?: string;
		preview?: boolean;
	} = $props();
	let content = $derived(broadcastText(title, body, textEntities));
</script>

<div class="bubble">
	<MediaAlbum media={attachments} />
	<MessageText text={content.text} entities={content.textEntities} />
</div>
{#if link}<BroadcastLink {link} {messageId} {preview} />{/if}

<style>
	.bubble {
		padding: var(--spacing-s) var(--spacing-m);
		border-radius: var(--radius-m);
		background: var(--background-surface);
		color: var(--text-primary);
		font: var(--text-body);
		overflow-wrap: anywhere;
	}
</style>
